export default __webpack_public_path__ + "assets/list-numbered.8298a0c9.svg";